// extracted by mini-css-extract-plugin
export default {"inline-group":"InlineGroup_inline-group__cdJv+"};